import { jsxs as u, jsx as e } from "react/jsx-runtime";
import '../../assets/Select.css';function f({
  label: r,
  id: c,
  options: t,
  onChange: n,
  onBlur: i,
  onFocus: s,
  onMouseEnter: o,
  onMouseLeave: h,
  className: m = "",
  defaultValue: d,
  value: p
}) {
  return /* @__PURE__ */ u("div", { className: "select " + m, children: [
    r && /* @__PURE__ */ e("label", { htmlFor: c, children: r }),
    /* @__PURE__ */ e(
      "select",
      {
        id: c,
        onChange: n,
        onBlur: i,
        onFocus: s,
        onMouseEnter: o,
        onMouseLeave: h,
        defaultValue: d,
        value: p,
        children: t.map(([l, a]) => /* @__PURE__ */ e("option", { value: l, children: a }, l))
      }
    )
  ] });
}
export {
  f as Select
};
//# sourceMappingURL=Select.js.map
